// extracted by mini-css-extract-plugin
export default {"container":"Modal-module--container--X5DVq","video":"Modal-module--video--Gvh8c","button":"Modal-module--button--pQEqT"};